import { debounce } from "lodash";
import { useEffect, useState } from "react";

export interface UseWindowResizeOptions {
  debounceWaitTimer?: number;
}

export function useWindowSize({
  debounceWaitTimer = 200,
}: UseWindowResizeOptions = {}) {
  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }
    const debouncedHandleResize = debounce(handleResize, debounceWaitTimer, {
      leading: true,
    });

    window.addEventListener("resize", debouncedHandleResize);

    // Call handler right away so state gets updated with initial window size
    debouncedHandleResize();

    return () => window.removeEventListener("resize", debouncedHandleResize);
  }, []);

  return windowSize;
}

export default useWindowSize;
